/**
 * Member feedback page (sections/member-feedback.liquid). Checks the star the Trustpilot
 * email link asked for (?rating=1-5), keeps the caption in step with the picked star, and
 * announces wl-feedback:* CustomEvents that assets/analytics-posthog-funnel.js names and
 * sends. Details carry the rating and field names only, never what the member typed.
 * After a post Shopify reloads the page without ?rating, so the picked rating is kept in
 * sessionStorage for the success and error views.
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-member-feedback]');
  if (!root) return;

  var STORAGE_KEY = 'wl-member-feedback-rating';
  var state = root.getAttribute('data-member-feedback') || 'form';
  var form = root.closest('form');
  var radios = Array.prototype.slice.call(root.querySelectorAll('input[data-feedback-rating]'));
  var caption = root.querySelector('[data-feedback-caption]');
  var stars = root.querySelector('.member-feedback__stars');

  function emit(name, detail) {
    document.dispatchEvent(new CustomEvent('wl-feedback:' + name, { detail: detail }));
  }

  function parseRating(value) {
    if (value === null || value === undefined) return null;
    var text = String(value).trim();
    return /^[1-5]$/.test(text) ? Number(text) : null;
  }

  function storedRating() {
    try {
      return parseRating(window.sessionStorage.getItem(STORAGE_KEY));
    } catch (e) {
      return null;
    }
  }

  function storeRating(rating) {
    try {
      if (rating) window.sessionStorage.setItem(STORAGE_KEY, String(rating));
    } catch (e) {}
  }

  function checkedRating() {
    for (var i = 0; i < radios.length; i++) {
      if (radios[i].checked) return parseRating(radios[i].value);
    }
    return null;
  }

  function renderCaption(rating) {
    // The fill for browsers without :has(); the CSS keys off data-rating as well.
    if (stars) stars.setAttribute('data-rating', rating ? String(rating) : '');
    if (!caption) return;
    caption.textContent = rating
      ? (caption.getAttribute('data-picked') || '').replace('[rating]', rating)
      : caption.getAttribute('data-empty') || '';
  }

  function select(rating) {
    radios.forEach(function (radio) {
      radio.checked = parseRating(radio.value) === rating;
    });
    renderCaption(rating);
  }

  var rawRating = null;
  try {
    rawRating = new URLSearchParams(window.location.search).get('rating');
  } catch (e) {}

  var rating = parseRating(rawRating);
  var ratingSource = rawRating === null ? 'none' : rating ? 'link' : 'invalid';

  if (!rating && checkedRating()) {
    // The browser put a picked star back (Back / reload).
    rating = checkedRating();
    ratingSource = 'restored';
  } else if (!rating && state !== 'form' && storedRating()) {
    rating = storedRating();
    ratingSource = 'restored';
  }

  if (radios.length) select(rating);

  emit('view', { rating: rating, rating_source: ratingSource, state: state });

  if (state === 'error') {
    var errorFields = (root.getAttribute('data-feedback-errors') || '').split(',').filter(Boolean);
    emit('failed', { rating: rating, reason: 'server', fields: errorFields });
  }

  if (!form || !radios.length) return;

  var current = rating;
  radios.forEach(function (radio) {
    radio.addEventListener('change', function () {
      var next = parseRating(radio.value);
      if (!radio.checked || next === current) return;
      emit('rating-change', { rating: next, previous_rating: current });
      current = next;
      storeRating(next);
      renderCaption(next);
    });
  });

  // Native validation stops the submit and fires invalid on each failing field; report the
  // attempt once, with field names only.
  var invalidFields = [];
  var invalidTimer = null;
  form.addEventListener(
    'invalid',
    function (e) {
      var target = e.target;
      var field = target.hasAttribute('data-feedback-rating') ? 'rating' : target.getAttribute('data-feedback-field');
      if (field && invalidFields.indexOf(field) === -1) invalidFields.push(field);
      if (invalidTimer) return;
      invalidTimer = window.setTimeout(function () {
        emit('failed', { rating: checkedRating(), reason: 'invalid', fields: invalidFields.slice() });
        invalidFields = [];
        invalidTimer = null;
      }, 0);
    },
    true
  );

  form.addEventListener('submit', function () {
    var picked = checkedRating();
    var order = form.querySelector('[data-feedback-field="order_number"]');
    storeRating(picked);
    emit('submit', { rating: picked, has_order_number: !!(order && order.value.trim()) });
  });
})();
